/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiRentVariant, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of RentVariantsController.
 */
export class RentVariantsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /rent_variants:prefill
     */
    public createPrefilled(): Promise<Result<ApiRentVariant>> {
        return this.http.post<Result<ApiRentVariant>, undefined>('/rent_variants:prefill', undefined);
    }

    /**
     * Calls GET /rent_variants:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiRentVariant>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiRentVariant>>>('/rent_variants:query', query);
    }

    /**
     * Calls POST /rent_variants:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiRentVariant>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiRentVariant>>, ListRequest>('/rent_variants:query', listRequest, query);
    }

    /**
     * Calls POST /rent_variants/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiRentVariant>>> {
        return this.http.post<Result<LockedContextDto<ApiRentVariant>>, undefined>(`/rent_variants/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /rent_variants/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiRentVariant>> {
        return this.http.post<Result<ApiRentVariant>, undefined>(`/rent_variants/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /rent_variants/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiRentVariant[]>> {
        return this.http.post<Result<ApiRentVariant[]>, string[]>('/rent_variants/locks', ids);
    }

    /**
     * Calls POST /rent_variants/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/rent_variants/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /rent_variants/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/rent_variants/${primaryId}/locks`);
    }

    /**
     * Calls GET /rent_variants/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiRentVariant>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiRentVariant>>(`/rent_variants/${primaryId}`, query);
    }

    /**
     * Calls POST /rent_variants
     */
    public add(dto: ApiRentVariant): Promise<Result<ApiRentVariant>> {
        return this.http.post<Result<ApiRentVariant>, ApiRentVariant>('/rent_variants', dto);
    }

    /**
     * Calls PUT /rent_variants/{primaryId}
     */
    public update(dto: ApiRentVariant, primaryId: string): Promise<Result<ApiRentVariant>> {
        return this.http.put<Result<ApiRentVariant>, ApiRentVariant>(`/rent_variants/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /rent_variants
     */
    public putRange(dtos: ApiRentVariant[]): Promise<Result<ApiRentVariant[]>> {
        return this.http.patch<Result<ApiRentVariant[]>, ApiRentVariant[]>('/rent_variants', dtos);
    }

    /**
     * Calls DELETE /rent_variants/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/rent_variants/${primaryId}`);
    }

    /**
     * Calls POST /rentvariants:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiRentVariant>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiRentVariant>>, ListRequestWithIds>('/rentvariants:batch', listRequest, query);
    }
}
